import { useAtomValue } from 'jotai';

import { activeRightSidebarAtom } from '@frontend/atoms';
import { NotificationTray } from '@frontend/features/notifications';

import { RightSidebar } from './RightSidebar';

export function RightSidebarHost() {
  const activeRightSidebar = useAtomValue(activeRightSidebarAtom);

  if (activeRightSidebar === 'notifications') {
    return (
      <RightSidebar ariaLabel="Notifications">
        <NotificationTray />
      </RightSidebar>
    );
  }

  return null;
}
